<template>
  <div>
    <layout-head :navActive="2"></layout-head>
    <div class="multimedia_index">
      <div class="warp12">
        <div class="search_container">
          <el-input v-model.trim="searText" placeholder="搜索你想知道的" @keyup.enter.native="checkList"></el-input>
          <img src="@/assets/image/index/search_btn.png" alt class="search_btn" @click="checkList" />
        </div>
        <div class="tllm_container">
          <div class="tllm_l">
            <img src="@/assets/image/multimedia/index_l.png" alt />
          </div>
          <div class="tllm_r">
            <h3>头条栏目</h3>
            <ul>
              <li @click="goDetails(code, item.fileID)" v-for="(item,index) in tllmList" :key="index" :title="item.fileName">· {{item.fileName}}</li>
            </ul>
            <div class="tllm_more">
              <a @click="goTopicList('全部', '001')">查看更多 +</a>
            </div>
          </div>
        </div>
        <div class="new_commond">
          <div class="blue_title">
            <h2>最新推荐</h2>
            <a @click="goTopicList2('new','001')" class="blue_title_more">查看更多 +</a>
          </div>
          <ul>
            <li v-for="(item,index) in newList" :key="index">
              <div class="new_item" @click="goDetails(code, item.fileID)">
                <!-- <div class="new_tip">
                  <img src="@/assets/image/multimedia/icon-video.png" alt />
                  <span>{{item.tip}}</span>
                </div> -->
                <img :src="item.coverUrl" alt class="new_img" />
                <div class="new_commond_line">
                  <div>
                    <img src="@/assets/image/multimedia/icon-view2.png" alt />
                    <span>{{ item.visitCount }}</span>
                  </div>
                  <!-- <div>
                    <img src="@/assets/image/multimedia/icon-fav.png" alt />
                    <span>{{ item.clollect }}</span>
                  </div> -->
                </div>
              </div>
              <div class="new_item_bottom">
                <p :title="item.fileName">{{ item.fileName }}</p>
                <p>{{ item.theme }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="white_container">
        <div class="warp12">
          <div class="blue_title">
            <h2>最热榜单</h2>
            <a @click="goTopicList2('hot','001')" class="blue_title_more">查看更多 +</a>
          </div>
          <div class="hot_container">
            <div class="hot_l">
              <ul>
                <li v-for="(item,index) in hotList" :key="index" @click="goDetails(code, item.fileID)" :title="item.fileName">
                 <div v-if="index<4">
                  <i></i>
                  <span>0{{index+1}}</span>
                  <p>{{ item.fileName }}</p>
                 </div>
                </li>
              </ul>
            </div>
            <div class="hot_r">
              <div v-for="(item,index) in hotList" :key="index">
                <div class="hot_r_item" v-if="index>3" @click="goDetails(code, item.fileID)">
                  <img :src="item.coverUrl" class="hot_img" :alt="item.fileName" />
                  <div class="hot_tip" :title="item.fileName">{{ item.fileName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="warp12 theme_container">
        <div class="blue_title">
          <h2>专题推荐</h2>
          <a class="blue_title_more" @click="goTopicList('全部', '001')">查看更多 +</a>
        </div>
        <div class="theme_list">
          <div v-for="(item,index) in themeList" :key="index" class="theme_item" @click="goTopicList(item, '001')">
            <img :src="require('@/assets/image/multimedia/img'+Number(index+1)+'.png')" class="theme_img" alt />
            <div class="theme_tip">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getData, getTypeData } from '@/assets/js/api'
export default {
  name: 'multimediaIndex',
  components: { layoutHead, layoutFooter },
  data () {
    return {
      searText: '',
      tllmList: [
        { title: ' “控温外衣”“智能管理员”…揭秘护航神舟十四号的“黑科技”' },
        { title: ' “控温外衣”“智能管理员”…揭秘护航神舟十四号的“黑科技”' },
        { title: ' “控温外衣”“智能管理员”…揭秘护航神舟十四号的“黑科技”' },
        { title: ' “控温外衣”“智能管理员”…揭秘护航神舟十四号的“黑科技”' },
        { title: ' “控温外衣”“智能管理员”…揭秘护航神舟十四号的“黑科技”' }
      ],
      newList: [
        {
          title: '海洋环境中的塑料污染如何治理',
          liulan: '1203',
          clollect: '1150',
          img: require('@/assets/image/multimedia/newimg.png'),
          tip: '原创',
          type: '视频-环境与安全'
        },
        {
          title: '海洋环境中的塑料污染如何治理',
          liulan: '1203',
          clollect: '1150',
          img: require('@/assets/image/multimedia/newimg.png'),
          tip: '原创',
          type: '视频-环境与安全'
        },
        {
          title: '海洋环境中的塑料污染如何治理',
          liulan: '1203',
          clollect: '1150',
          img: require('@/assets/image/multimedia/newimg.png'),
          tip: '原创',
          type: '视频-环境与安全'
        },
        {
          title: '海洋环境中的塑料污染如何治理',
          liulan: '1203',
          clollect: '1150',
          img: require('@/assets/image/multimedia/newimg.png'),
          tip: '原创',
          type: '视频-环境与安全'
        }
      ],
      hotList: [
        {
          title: '长途列车上喝水吃饭',
          img: require('@/assets/image/multimedia/hot1.png')
        },
        {
          title: '长途列车上喝水吃饭',
          img: require('@/assets/image/multimedia/hot2.png')
        },
        {
          title: '长途列车上喝水吃饭',
          img: require('@/assets/image/multimedia/hot3.png')
        },
        {
          title: '长途列车上喝水吃饭',
          img: require('@/assets/image/multimedia/hot4.png')
        }
      ],
      themeList: [],
      code: '001'
    }
  },
  created () {
    this.getHotList()
    this.getNewList()
    this.getTypeList()
    this.getTllmList()
  },
  methods: {
    goTopicList (item, code) {
      this.$router.push({
        name: 'topic',
        query: {
          item: item,
          code: code
        }
      })
    },
    goTopicList2 (type, code) {
      this.$router.push({
        name: 'topic',
        query: {
          type: type,
          code: code
        }
      })
    },
    goDetails (code, id) {
      this.$router.push({
        name: 'topicDetails',
        query: {
          id: id,
          code: code
        }
      })
    },
    getHotList () {
      const params = {
        code: this.code,
        orderBy: 'visitCount',
        size: '8',
        current: '1'
      }
      getData(params).then((res) => {
        if (res.code === '200') {
          this.hotList = res.content.data
        }
      })
    },
    getNewList () {
      const params = {
        code: this.code,
        orderBy: 'updateTime',
        size: '4',
        current: '1'
      }
      getData(params).then((res) => {
        if (res.code === '200') {
          this.newList = res.content.data
        }
      })
    },
    getTypeList () {
      getTypeData({ code: '001' }).then((res) => {
        if (res.code === '200') {
          this.themeList = res.content
        }
      })
    },
    getTllmList () {
      const params = {
        code: this.code,
        theme: '食品安全',
        size: '5',
        current: '1'
      }
      getData(params).then((res) => {
        if (res.code === '200') {
          this.tllmList = res.content.data
        }
      })
    },
    checkList () {
      this.$router.push({
        name: 'topic',
        query: {
          item: '全部',
          code: this.code,
          searText: this.searText
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.multimedia_index {
  margin-top: -387px;
  position: relative;
  .tllm_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 48px;
    .tllm_l {
      width: 600px;
      height: 280px;
      background: #eff1f8;
      padding: 2px;
      box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .tllm_r {
      width: 560px;
      height: 280px;
      background: url(@/assets/image/multimedia/ttlm_bg.png) no-repeat center
        center;
      background-size: 100% 100%;
      position: relative;
      padding: 30px 49px 30px 30px;
      h3 {
        position: absolute;
        font-size: 20px;
        color: #ffffff;
        top: -13px;
        left: 20px;
      }
      ul {
        li {
          color: #ffffff;
          line-height: 36px;
          font-size: 16px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .tllm_more {
        text-align: right;
        padding-top: 20px;
        a {
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
  .new_commond {
    margin-top: 66px;
    padding-bottom: 58px;
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        cursor: pointer;
          width: 267px;
        .new_item {
        width: 100%;
          height: 167px;
          padding: 4px;
          border-radius: 5px;
          background: #fff;
          box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);
          position: relative;
          .new_tip {
            position: absolute;
            width: 70px;
            height: 24px;
            background: rgba(236, 105, 65, 0.7);
            border-radius: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #ffffff;
            top: 13px;
            left: 12px;
            img {
              margin-right: 5px;
            }
          }
          .new_img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .new_commond_line {
            position: absolute;
            bottom: 4px;
            left: 4px;
            width: 258px;
            height: 30px;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 6px;
            font-size: 14px;
            color: #f9fafc;
            div {
              display: flex;
              align-items: center;
            }
            img {
              margin-right: 6px;
            }
          }
        }
        .new_item_bottom {
          padding: 0 7px;
          margin-top: 9px;
          width: 100%;
          p {
            width: 100%;
            line-height: 30px;
            color: #333333;
            font-size: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:last-child {
              color: #666666;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .white_container {
    padding: 43px 0;
    background: #fff;
  }
  .hot_container {
    display: flex;
    align-items: center;
    .hot_l {
      width: 288px;
      margin-right: 44px;
      ul {
        width: 100%;
        li {
          margin-bottom: 30px;
          width: 100%;
          cursor: pointer;
          div {
            display: flex;
          align-items: center;
          position: relative;
          width: 100%;
          }
          &::before {
            content: "";
            width: 2px;
            height: 52px;
            background-color: #2883f4;
            position: absolute;
            top: 22px;
            left: 3px;
          }
          i {
            width: 8px;
            height: 8px;
            background: #2883f4;
            border: 1px solid #ffffff;
            border-radius: 50%;
            margin-right: 13px;
          }
          span {
            font-size: 24px;
            color: #ff6d01;
            margin-right: 10px;
          }
          p {
            width: 250px;
            color: #333333;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &:last-child {
            margin-bottom: 0;
            &::before {
              display: none;
            }
          }
        }
      }
    }
    .hot_r {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .hot_r_item {
        width: 208px;
        height: 198px;
        padding: 4px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);
        position: relative;
        cursor: pointer;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
        .hot_tip {
          width: 200px;
          height: 30px;
          line-height: 30px;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: 4px;
          left: 4px;
          font-size: 16px;
          padding: 0 10px;
          color: #ffffff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
